export const LOAD_INSTRUMENT_LIST = 'neo-trading/dashboard/LOAD_INSTRUMENT_LIST';
export const LOAD_INSTRUMENT_LIST_SUCCESS = 'neo-trading/dashboard/LOAD_INSTRUMENT_LIST_SUCCESS';
export const LOAD_INSTRUMENT_LIST_FAILURE = 'neo-trading/dashboard/LOAD_INSTRUMENT_LIST_FAILURE';
export const CLOSE_SOCKET_DATA = 'neo-trading/dashboard/CLOSE_SOCKET_DATA';
export const UPDATE_SOCKET_DATA = 'neo-trading/dashboard/UPDATE_SOCKET_DATA';
export const LOAD_SOCKET_DATA = 'neo-trading/dashboard/LOAD_SOCKET_DATA';
export const SUBSCRIBE_TIER='neo-trading/dashboard/SUBSCRIBE_TIER';
export const UNSUBSCRIBE_TIER='neo-trading/dashboard/UNSUBSCRIBE_TIER';
export const UPDATE_STATUS ='neo-trading/dashboard/UPDATE_STATUS';
export const SUCCESS_DEFAULT = 'neo-trading/dashboard/SUCCESS_DEFAULT';
export const FAILURE_DEFAULT = 'neo-trading/dashboard/FAILURE_DEFAULT';
export const LOAD_MARGINCOMPONENT = 'neo-trading/dashboard/LOAD_MARGINCOMPONENT';
export const UPDATE_MARGINDATA = 'neo-trading/dashboard/UPDATE_MARGINDATA';
export const LOAD_MARGIN = 'neo-trading/dashboard/LOAD_MARGINDATA';
export const LOAD_MARGIN_SUCCESS = 'neo-trading/dashboard/LOAD_MARGIN_SUCCESS';
export const LOAD_MARGIN_FAILURE = 'neo-trading/dashboard/LOAD_MARGIN_FAILURE';
export const LOAD_ACCBAL='neo-trading/dashboard/LOAD_ACCBAL';
export const UPDATE_ACCBAL='neo-trading/dashboard/UPDATE_ACCBAL';
export const UPDATE_INST='neo-trading/dashboard/UPDATE_INST';
export const UPDATE_MARGIN_PERC='neo-trading/dashboard/UPDATE_MARGIN_PERC';
export const ACC_CHANGE='neo-trading/dashboard/ACC_CHANGE';
export const ACC_CHANGE_SUCCESS='neo-trading/dashboard/ACC_CHANGE_SUCCESS';
export const ACC_CHANGE_FAILURE='neo-trading/dashboard/ACC_CHANGE_FAILURE';
export const SOCKET_FLAG='neo-trading/dashboard/SOCKET_FLAG';
export const UPDATE_VALUEDATE='neo-trading/dashboard/UPDATE_VALUEDATE';
export const RESET_STATE_SOCKET = 'neo-trading/dashboard/RESET_STATE_SOCKET';
export const RESET_SOCKET_DATA = 'neo-trading/dashboard/RESET_SOCKET_DATA';
export const OPEN_TRADE = 'neo-trading/dashboard/OPEN_TRADE';
export const LOAD_MARKUP='neo-trading/dashboard/LOAD_MARKUP';
export const LOAD_MARKUP_SUCCESS='neo-trading/dashboard/LOAD_MARKUP_SUCCESS';
export const LOAD_MARKUP_FAILURE='neo-trading/dashboard/LOAD_MARKUP_FAILURE';
export const UPDATE_STK_MARKUP='neo-trading/dashboard/UPDATE_STK_MARKUP';
export const UPDATE_STK_MASTER='neo-trading/dashboard/UPDATE_STK_MASTER';
export const LOAD_ALL_RATE_DATA='neo-trading/dashboard/LOAD_ALL_RATE_DATA';
export const LOAD_ALL_INSTRUMENTS = 'neo-trading/dashboard/LOAD_ALL_INSTRUMENTS';
export const LOAD_ALL_INSTRUMENTS_SUCCESS = 'neo-trading/dashboard/LOAD_ALL_INSTRUMENTS_SUCCESS';
export const LOAD_ALL_INSTRUMENTS_FAILURE = 'neo-trading/dashboard/LOAD_ALL_INSTRUMENTS_FAILURE';
export const NO_MARGIN_LOAD = 'neo-trading/dashboard/NO_MARGIN_LOAD';
export const NO_MARGIN_LOAD_SUCCESS = 'neo-trading/dashboard/NO_MARGIN_LOAD_SUCCESS';
export const NO_MARGIN_LOAD_FAILURE = 'neo-trading/dashboard/NO_MARGIN_LOAD_FAILURE';
export const UPDATEMARGIN = '';